import React from "react"
import { Box, Divider, makeStyles } from "@material-ui/core"
import goop from "../../images/goopLogo.svg"
import npr from "../../images/npr-logo.svg"
import nbc from "../../images/nbcLogo.png"
import oprah from "../../images/oprah-winfrey-logo.png"
import abc from "../../images/abcLogo.png"
import cbs from "../../images/cbsLogo.png"
import bulletProof from "../../images/pp_icon_bullet_proof.png"

const Featured = () => {
  const useStyles = makeStyles(theme => ({
    logo: {
      width: "100%",
      maxWidth: 130,
      minWidth: 75,
    },
    logoSm: {
      width: "100%",
      maxWidth: 80,
      // minWidth: 50
    },
    chip: {
      margin: theme.spacing(1),
    },
    outer: {
      overflow: "hidden",
    },
  }))

  const classes = useStyles()

  return (
    <Box mt={4} className={classes.outer}>
      <Box
        width={1}
        display={"flex"}
        flexWrap={{ xs: "wrap", md: "noWrap" }}
        justifyContent="center"
        pt={2}
      >
        <Box mr={4} style={{ marginTop: 30 }}>
          {" "}
          <img
            style={{ maxWidth: 100 }}
            className={classes.logo}
            src={goop}
          />{" "}
        </Box>
        <Box mr={4} style={{ marginTop: 25 }}>
          {" "}
          <img className={classes.logo} src={npr} />{" "}
        </Box>
        <Box mr={4}>
          {" "}
          <img className={classes.logoSm} src={nbc} />{" "}
        </Box>
        <Box mr={4}>
          {" "}
          <img className={classes.logo} src={oprah} />{" "}
        </Box>
        <Box mr={4}>
          {" "}
          <img className={classes.logo} src={bulletProof} />{" "}
        </Box>
        <Box mr={4}>
          {" "}
          <img className={classes.logo} src={abc} />{" "}
        </Box>
        <Box mr={4} style={{ marginTop: 20 }}>
          {" "}
          <img className={classes.logo} src={cbs} />{" "}
        </Box>
      </Box>
      <Box my={3}>
        <Divider />
      </Box>
    </Box>
  )
}

export default Featured
